import { type FC } from "react";
import { type DotProps } from "recharts";

import { DatasetChart, type IConditionCombination } from "./DatasetChart.js";

export interface ICustomDotProps {
  getSelectionCount: (fields: string[]) => number;
  getSelectedRawData: (data) => Array<{ key: string; value: number }>;
  getSelectionYPosition: (value: number) => number;
  symbolSize: number;
}

interface IInjectedCustomDotProps extends ICustomDotProps, Omit<DotProps, "name"> {
  payload: IConditionCombination; // not sure why this difference between dot and bar: the payload is injected at this level
}

/**
 * Custom dot for line chart.
 *
 * created on 2/16/2018
 */
const CustomDot: FC<ICustomDotProps> = (props: IInjectedCustomDotProps) => {
  const { cx, cy } = props; // injected via DotProps
  const { fill, stroke, strokeWidth } = props; // injected via RectangleProps
  const { payload } = props; // injected via RectangleProps

  if (cy === null || isNaN(cy)) {
    return null;
  }

  // const fullySelected: boolean = this.allSelected(this.props.chartSelection, fields);
  // we calculate the amount of items corresponding to the bar so that we can show visually the proportion of the bar that is actually selected (from the table)
  const selectionCount: number = props.getSelectionCount(payload.fields);
  const selectionProps: any =
    selectionCount === 0
      ? {}
      : {
          stroke: DatasetChart.COLOR_SELECTION,
          strokeWidth: 3,
          r: props.symbolSize > 0 ? props.symbolSize : props.symbolSize + 1, // even if the symbols are not shown, we want to see the selected positions
        };

  // infer the position of the selected raw data from the side table
  const selectedRawData: Array<{ key; value }> = props.getSelectedRawData((props as any).payload);

  return (
    <g>
      <circle
        cx={cx}
        cy={cy}
        r={props.symbolSize}
        stroke={stroke}
        strokeWidth={strokeWidth}
        fill={fill}
        {...selectionProps}
      />
      {selectedRawData.map((rawData: { key; value }, index: number) => (
        <circle
          cx={cx}
          cy={props.getSelectionYPosition(rawData.value)}
          r={props.symbolSize < 2 ? props.symbolSize + 2 : props.symbolSize + 1}
          key={`chart_sel_dot_${index}`}
          stroke={DatasetChart.TABLE_COLOR_SELECTION}
          strokeWidth={2}
          fill={"transparent"}
        >
          <title>{rawData.value}</title>
        </circle>
      ))}
    </g>
  );
};

export default CustomDot;
